'use strict';

export const EGIS_SERVICE_CALLER: string = 'OK.Egis.Portal';
export const MAX_INT32_VAL: number = 2147483647;
